module.exports = __webpack_public_path__ + "static/media/icon-drag-handle.40389cd5.svg";